export const productSettingsIds = {
    metaFields: "metaFields",
    subAndSave: "subAndSave",
    productImage: "productImage",
    addToCartAndBuyNowBtn: "addToCartAndBuyNowBtn",
    variants: "variants",
    htmlBlock: "htmlBlock"
}